import axios from "axios";
import { Platform } from "react-native";
import config from "../oneconfig";
import FormData from "form-data";

export interface SearchUserType {
  name: string;
  pesel: string;
  firstName: string;
  lastName: string;
  email: string;
  _id: string;
}

export const EMPTY_USER = {
  _id: "-1",
  firstName: "",
  lastName: "",
  name: "",
  email: "",
  pesel: "",
};

export const getAllUsers = async () => {
  try {
    // console.log(`[AXIOS] default headers `, JSON.stringify(axios.defaults.headers.common));
    const response = await axios.get(
      config.api_url + "/usersWithParticipationFlag"
    );
    return response.data;
  } catch (error) {
    console.log("[error]", error, JSON.stringify(error));
    throw error;
  }
};

export const getDeafUsersForSearch = async () => {
  try {
    // console.log(`[AXIOS] default headers `, JSON.stringify(axios.defaults.headers.common));
    const response = await axios.get(config.api_url + "/deaf-users-for-search");
    return response.data;
  } catch (error) {
    console.log("[error]", error, JSON.stringify(error));
    throw error;
  }
};

export const getTranslatorsForSearch = async () => {
  try {
    // console.log(`[AXIOS] default headers `, JSON.stringify(axios.defaults.headers.common));
    const response = await axios.get(
      config.api_url + "/translators-for-search"
    );
    return response.data;
  } catch (error) {
    console.log("[error]", error, JSON.stringify(error));
    throw error;
  }
};

export const getUser = async (id: string) => {
  try {
    // console.log(`[AXIOS] default headers `, JSON.stringify(axios.defaults.headers.common));
    const response = await axios.get(config.api_url + `/user/${id}`);
    return response.data;
  } catch (error) {
    console.log("[error]", error, JSON.stringify(error));
    throw error;
  }
};

export const deleteUser = async (id: string) => {
  try {
    // console.log(`[AXIOS] default headers `, JSON.stringify(axios.defaults.headers.common));
    const response = await axios.delete(config.api_url + `/user/${id}/delete`);
    return response.data;
  } catch (error) {
    console.log("[error]", error, JSON.stringify(error));
    throw error;
  }
};

export const createUser = async (data: any) => {
  const createUserUrl = `${config.api_url}/user`;
  console.log(`create user via url  ${createUserUrl} `);
  // const fileStream = fs.createReadStream(data.file.uri);
  const form = new FormData();

  form.append("email", data.email);
  form.append("password", data.password);
  form.append("password2", data.password2);
  form.append("firstName", data.firstName);
  form.append("lastName", data.lastName);

  form.append(
    "role",
    data.isTranslator ? "translator" : data.isEditor ? "editor" : "user"
  );

  console.log(`creating User with ${JSON.stringify(form)}`);

  return await axios({
    url: createUserUrl,
    method: "post",
    data: form,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateUser = async (data: any) => {
  const updateUserUrl = `${config.api_url}/user/${data.id}`;
  console.log(`form ${JSON.stringify(data)}`);
  console.log(`update  via  ${updateUserUrl} `);

  const form = new FormData();
  form.append("id", data.id);

  form.append("email", data.email);
  form.append("firstName", data.firstName);
  form.append("lastName", data.lastName);
  form.append("pesel", data.pesel);
  form.append("isActive", data.isActive);
  form.append("isParticipationFormFinished", data.isParticipationFormFinished);
  form.append("declaredRefugee", data.declaredRefugee);
  form.append(
    "preferredWrittenCommunication",
    data.preferredWrittenCommunication
  );

  form.append(
    "role",
    data.isTranslator
      ? "translator"
      : data.isEditor
      ? "editor"
      : data.isTranscriber
      ? "transcriber"
      : data.isAdmin
      ? "admin"
      : "user"
  );

  console.log(
    `old disability file name`,
    data.previousDisabilityDocumentFileName
  );

  if (data.disabilityDocument && data.disabilityDocumentChanged) {
    console.log(`new disability file name`, data.disabilityDocument.name);
    console.log(`uploading changed file name`, data.disabilityDocument.name);

    const res = await fetch(data.disabilityDocument.uri);
    const b = await res.blob();
    form.append("disabilityDocument", b, data.disabilityDocument.name);
  }

  return await axios({
    url: updateUserUrl,
    method: "patch",
    data: form,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

//Function that returns a promise to read the file
const reader = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.readAsDataURL(file);
  });
};
const readFile = async (file) => {
  // return await reader(file);
  reader(file).then((result) => {
    console.log("************");
    console.log(result);
  });
};

export const signUpCall = async (data: any) => {
  const signup_url = `${config.api_url}/auth/signup`;

  console.log(`register via url  ${signup_url} `);

  const form = new FormData();

  if (data.disabilityDocument) {
    if (Platform.OS === "web") {
      const res = await fetch(data.disabilityDocument.uri);
      const b = await res.blob();
      form.append("disabilityDocument", b, data.disabilityDocument.name);
    } else {
      console.log(
        `data.disabilityDocument.mimeType: ${JSON.stringify(
          data.disabilityDocument.mimeType
        )} `
      );

      console.log(
        `data.disabilityDocument.name: ${JSON.stringify(
          data.disabilityDocument.name
        )} `
      );

      form.append("disabilityDocument", {
        uri: data.disabilityDocument.uri,
        type:
          /*   Platform.OS === "android"
            ? "image/jpg"
            :  */
          data.disabilityDocument.mimeType,
        name: data.disabilityDocument.name,
      });
    }
  } else {
    console.log(`data.disabilityDocument is null`);

    // xman  to be changed to developmnet env only
    // just for testing when disability is not attached correctly
    // needs proper fix
    const uriData =
      "data:image/png;base64,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";
    const b = new Blob([JSON.stringify(uriData)]);
    form.append("disabilityDocument", b, data.disabilityDocumentFileName);
  }

  form.append("email", data.email);
  form.append("password", data.password);
  form.append("password2", data.password2);
  form.append("emailConfirm", data.email);
  form.append("firstName", data.firstName);
  form.append("lastName", data.lastName);
  form.append("phone", data.phone);
  form.append("declaredRefugee", data.declaredRefugee);
  form.append(
    "preferredWrittenCommunication",
    data.preferredWrittenCommunication
  );

  console.log(`about to send  request`);

  let resp = await fetch(signup_url, {
    method: "POST",
    body: form,
  });
  let jobj = await resp.json();
  let display = jobj.display;
  console.log(resp.status);
  console.log(display);

  return { status: resp.status, response: jobj };
};

export const closeOwnAccount = async (reason: string) => {
  try {
    // console.log(`[AXIOS] default headers `, JSON.stringify(axios.defaults.headers.common));

    const response = await axios.post(config.api_url + "/close-own-account", {
      reason: reason,
    });

    return response.data;
  } catch (error) {
    console.log("[error]", error, JSON.stringify(error));
    throw error;
  }
};
